import { cfgToThemeCdnPath } from '@infinitro/config';
const flushAssets = {
    background: cfgToThemeCdnPath(`/about-vip/vip-background.png`),
    coins: cfgToThemeCdnPath(`/about-vip/coins.png`),
    coin: cfgToThemeCdnPath(`/about-vip/coin.png`),
    card1: cfgToThemeCdnPath(`/about-vip/card_1.png`),
    card2: cfgToThemeCdnPath(`/about-vip/card_2.png`),
    card3: cfgToThemeCdnPath(`/about-vip/card_3.png`),
    card4: cfgToThemeCdnPath(`/about-vip/card_4.png`),
    card5: cfgToThemeCdnPath(`/about-vip/card_5.png`),
    step1: cfgToThemeCdnPath(`/about-vip/step1.png`),
    step2: cfgToThemeCdnPath(`/about-vip/step2.png`),
    step3: cfgToThemeCdnPath(`/about-vip/step3.png`),
    chests: cfgToThemeCdnPath(`/about-vip/chests.png`),
    cardsLeft: cfgToThemeCdnPath(`/about-vip/cards_left.png`),
    cardsRight: cfgToThemeCdnPath(`/about-vip/cards_right.png`),
    rocketPlanet: cfgToThemeCdnPath(`/about-vip/space-illustration.png`),
    crown: cfgToThemeCdnPath(`/about-vip/crown-illustration.png`),
    banner: cfgToThemeCdnPath(`/about-vip/banner-background.png`),
    modalHeader: cfgToThemeCdnPath(`/about-vip/modal-header.png`),
    royaltyBanner: cfgToThemeCdnPath(`/about-refer-and-earn/banner-background.png`),
    royaltyBannerMobile: cfgToThemeCdnPath(`/about-refer-and-earn/banner-background-mobile.png`)
};
export default flushAssets;
